import { LOCKER_SLUG } from "./BrowserStorageKeys";

export const PWA_DOMAIN_DEV = "https://pwadev.durolt.in";
export const PWA_DOMAIN_PROD = "https://luggage.durolt.com";
export const API = "api";
export const PWA = "pwa";
export const LUGGAGE = "luggage";
export const LUGGAGE_SETTINGS = "luggage-settings";
export const SEND_OTP = "send-otp";
export const VERIFY_OTP = "verify-otp";
export const AVAILABLE_SIZES = "available-sizes";
export const INITIATE_PAYMENT = "initiate-payment";
export const BOOKING_TYPE_NEW = "new";
export const BOOKING_TYPE_ADDITIONAL = "additional";
export const POST_PAYMENT = "post-payment";
export const LOCKER_BANK = "locker-bank";
export const LOCKER_BANK_TYPE = "locker_bank";
export const POD_BANK_TYPE = "pod";
export const ASSIGNED_LOCKERS = "assigned-lockers";
export const OPEN_LOCKER = "open-locker";
export const RELEASE_LOCKER = "release-locker";
export const GET = "GET";
export const POST = "POST";
export const SUCCESS = "success";
export const ERROR = "error";
export const REDIRECT = "redirect";
export const GUEST_AUTH_TOKEN = 'GUEST-AUTH-TOKEN';
export const GUEST_AUTH_TOKEN_VALUE = "#up!7O@rh#55Fp3I1CpHQ!d5xs2J2c#FRc@x^bb@ZHTzK5@v5bCivAjSjAx^3Vhs";
export const HH_mm = "HH:mm";
export const HH_mm_ss = "HH:mm:ss";
export const NO_SIZE = "NS";
export const TRUSTED_LINKING_TOKEN = "TRUSTED-LINKING-TOKEN";
export const TRUSTED_LINKING_TOKEN_VAL='kj3YSSa*x3bgj2PHrkOJxz*TMT@v!PUK98uUS(WdnF#cZhZ^v4LEou4dpSOgAx8H'
export const PENDING = 'pending';
export const ASSIGNED = 'assigned'
export const RETURN = 'return'
export const POP = 'POP';
export const PUSH = 'PUSH';
export const PAYMENT_GATEWAY = 'payment-gateway';
export const INITIATE = 'initiate';
export const COD ='cod';
export const NON_OPERATIONAL = 'non_operational';
export const CAN_ACCESS_MOBILE_APP = 'can_access_mobile_app';
export const UPDATE_PAYMENT = "update-payment";
export const DARK = 'dark';
export const LIGHT = 'light';
export const INITIATED = 'initiated';
export const MAIN_HEADER_RIGHT_ICON = 'mainHeaderRightIcon';
export const MAIN_HEADER_LEFT_ICON = 'mainHeaderLeftIcon';
export const DONE = 'done';
export const ADD_ANOTHER = 'addAnotherParcel'
export const ASSIGNMENT_SLUG = 'ASSIGNMENT-SLUG'
export const DEVICE_ID = 'Device-Id'
export const DEVICE_TYPE = 'Device-Type'
export const EXPIRY_DATE_MASK = '99/99'
export const CARD_NUMBER_MASK = '9999 9999 9999 9999'
export const CLOSED = 'closed';
export const ECONNABORTED = 'ECONNABORTED';
export const DOOR_NOT_CLOSED = 'Door is not closed';
export const API_TIMEOUT_FOR_CLOSE_DOOR_API = 57000
export const LB_NOT_RESPOND = 'Locker Bank is Not Responding';
export const LB_OFFLINE = 'Locker Bank Is Offline';
export const MAX_RETRIES_FOR_CLOSE_ACTIVITY = 2;
export const NOT_OPENED = "Not Opened";
export const LOGOUT_TEXT = "logout";

// Customers
export const HIVEBOARD = 'HiveBoard';
export const DUROLT = 'Durolt';
export const BLUEDART = 'BlueDart';
export const GOLDGYM = 'GoldGym';

//Events
export const BACKSPACE = 'Backspace';
export const ENTER = 'Enter';

// OTPless authentication
export const OTPLESS_AUTHENTICATION_SOURCE = "https://otpless.com/auth.js";
export const OTPLESS_DUROLT_CID = "VCA1GURCQ7JRRAGY70FRFX9ZBXUJHDFV";

export const EASEBUZZ_PAYMENT_GATEWAY_ENV = "prod";
export const EASEBUZZ_PAYMENT_GATEWAY_SOURCE = "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js";
export const EASEBUZZ_DUROLT_MERCHANT_KEY = "ZJSW49MVY3";

export const RAZORPAY_PAYMENT_GATEWAY_SOURCE = 'https://checkout.razorpay.com/v1/checkout.js';

//Toast Message Types
export const TOAST_INFO = "INFO";
export const TOAST_WARN = "WARN";
export const TOAST_SUCCESS = "SUCCESS";
export const TOAST_ERROR = "ERROR";
export const BUTTON_SECONDARY = "secondary";
export const BUTTON_PRIMARY = "primary";
export const BUTTON_WARNING = 'warning'

export const DATE_TIME_SELECTOR_WEEKDAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
export const DATE_TIME_SELECTOR_MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
export const DATE_TIME_SELECTOR_DATE_OPTIONS = [
    { label: "Today", value: "today" },
    { label: "Tomorrow", value: "tomorrow" },
    { label: "\uD83D\uDCC5 Custom", value: "custom" },
];
export const DATE_TIME_SELECTOR_MAX_BOOKING_WINDOW_MONTHS = 6;
export const DATE_TIME_SELECTOR_MINIMUM_LEAD_TIME_MINUTES = 210;
export const DATE_TIME_SELECTOR_SLOT_INTERVAL_MINUTES = 30;
export const DATE_TIME_SELECTOR_LAST_TIME_SLOT = '11:30 PM';
export const DATE_TIME_SELECTOR_END_OF_DAY_HOURS = 23;
export const DATE_TIME_SELECTOR_END_OF_DAY_MINUTES = 30;
export const DUROLT_CONTACT_NUMBER = "079-4850-1080";


// Regular expressions
export const REGEXP_EMAIL = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
export const REGEXP_MOBILE = /^(\+91[\s]?)[6789]\d{9}$/; //currently validating only indian numbers.
export const REGEXP_OTP = /[0-9]{4}/i;
export const ALPHANUM_REGEX = /^[a-zA-Z0-9]+$/
export const REGEXP_DOMAIN = /^{.*(?="domain"\s*:\s*"(https:\/\/|http:\/\/)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\/").*}$/
export const REGEXP_LB_ID = /^{.*(?="lockerBankId"\s*:\s*"\d+").*}$/
export const REGEXP_DASH = /-/g;
export const REGEXP_NUMERIC = /^\d+$/;
export const AT_SYMBOL = "@";
export const REGEXP_DOT = /\./g;
// crypto.constants.js
export const BASE64_URL_CHARS_REGEX = /[A-Za-z0-9+/=_-]+/;
export const MIN_ENCRYPTED_LENGTH = 16;
export const THREE_HOURS = 3;
export const BOOK_NEW_LOCKER = "bookNewLocker";

//API Constants 
export const API_TIMEOUT = 10000 // 10 seconds
export const DUROLT_SUPPORT_URL = "https://durolt.com/contact-us/"
export const DUROLT_ABOUT_URL = "https://durolt.com/"
export const DUROLT_TERMS_CONDITIONS_URL = "https://durolt.com/terms-and-conditions-luggage-locker-usage/"
export const PHONE_PREFIX = '+'

export const listOfItemsInLocalStorageToKeep = [
    "DnLB",
    "selectedLanguage",
    "allowedLanguage",
    LOCKER_SLUG,
    "TenIn",
    "LBIn",
    "TALBSet",
    "PgFlw",
    "CsMr",
    "bId",
    "asSlu"
]; 

export const validPathsForSubHeader = [
    '/about-screen',
    '/support-screen',
    '/change-pin',
    '/forget-pin',
    '/team-locker',
    '/personal-locker',
    '/terms-and-conditions',
    '/organisation-list',
    '/select-locker-bank',
    '/select-zone',
    '/new-reserve-locker',
    '/select-user',
    '/profile-update',
    '/connect-mobile',
    '/parcel-details',
    '/assignments',
    '/drop-parcel',
    '/connect-mobile',
    '/locker-list',
    '/locker-layout',
    '/select-locker-size',
    '/locker-more-options',
    '/assign-locker',
    '/open-locker',
    '/open-parcel',
    '/payment-details',
    '/payment-completion',
    '/select-unit',
    '/swipe-to-open',
    '/locker-opened',
    '/my-lockers',
    '/sublocation-one',
    '/sublocation-two',
    '/sublocation-three',
    '/account-details',
    '/my-rented-products',
    '/faq',
    '/contact-us',
    '/privacy-policy',
    '/parcel-owner',
    '/parcel-pickup-door-verification',
    '/invoice',
    "/user-account"
];

export const validPathsForBackHeader = [
   '/equipment-details',
   '/verification-successful',
   '/payment-successful',
   '/unit-opened',
   '/capture-product-image'
];

export const excludePathsForFooter = [
]


export const validPathsforAlertBackParcelPages = [
    // '/about-screen',
]

export const validPathsforHideBackButtonFromHeader = [
    '/assignments',
]

export const validPathsForMainHeader = [
    '/home-screen',
    '/equipment-grid',
    '/map',
    '/locker-details',
    '/locker-size',
    '/booking-summary',
    '/admin-locker-door-oreration'
    
]

const constants = {
    DROP : 'drop',
    PICKUP : 'pickup',
}

const headerConstants = {
    DROP_PARCEL : 'Drop Parcel',
    PICKUP_PARCEL : 'Pickup Parcel',
}

export const OTP_EXPIRATION_TIME = 120; 

export const validPathsForPreventBack = [
    '/home-screen',
    '/equipment-grid',
    '/user-account',
]

export const pathsBeforeLoginForPrivateRoutes = [
    '/login-page',
    '/verify-otp',
    '/parcel-pickup-door-verification',
]

export const pathsValidForGestUsers = [
    '/map',
    '/custom-drawer',
    '/support-screen',
    '/terms-and-conditions',
    '/about-screen',
    '/invoice',
    '/user-account',
    '/locker-details',
    '/locker-size',
    '/booking-summary'
]
export const validPathForFooterLanguage = [
    '/login-page'
]

export const RAZORPAY_LANGUAGE_MAP = {
    en: "en",     // English
    hi: "hi",     // Hindi
    mr: "mar",    // Marathi
    kn: "kan",    // Kannada
    ta: "tam",    // Tamil
    te: "tel",    // Telugu
    bn: "ben"     // Bengali
};

export { constants,headerConstants }

// Use cases
export const ASSET_RENTAL_USE_CASE = 'asset_rental';
export const DYNAMIC_USE_CASE = 'dynamic';
export const LUGGAGE_USE_CASE = 'luggage';
export const PARCEL_USE_CASE = 'parcel';
export const IMPORT_EXPORT_USE_CASE = 'import_export';

// Page Flows based on use case
// Asset rental: Hiveboard
export const ASSET_RENTAL_PAGE_FLOW = [
    {
        "name": "qrCodeLanding",
        "path": "/locker-bank/:domainAndLockerBankInfoInBase64",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "accessLockerBank",
        "path": "/",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "assignmentSelection",
        "path": "/assignments",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            }
        ]
    },
    {
        "name": "login",
        "path": "/login-page",
        "exitPages": [
            {
                "key": "verifyOtp",
                "name": "verifyOtp",
                "path": "/verify-otp"
            },
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "verifyOtp",
        "path": "/verify-otp",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "equipmentGrid",
        "path": "/equipment-grid",
        "exitPages": [
            {
                "key": "equipmentDetails",
                "name": "equipmentDetails",
                "path": "/equipment-details"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
            {
                "key": "chatSupport",
                "name": "chatSupport",
                "path": "/chat-support"
            },
            {
                "key": "assignedLockers",
                "name": "myRentedProducts",
                "path": "/my-rented-products"
            }
        ]
    },
    {
        "name": "equipmentDetails",
        "path": "/equipment-details",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "externalPaymentGateway",
        "path": null,
        "exitPages": [
            {
                "key": "successPage",
                "name": "paymentDetailsVerified",
                "path": "/verification-successful"
            },
            {
                "key": "cancelOrErrorPage",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "paymentDetailsVerified",
        "path": "/verification-successful",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            },
            {
                "key": "equipmentDetails",
                "name": "equipmentDetails",
                "path": "/equipment-details"
            },
            {
                "key": "lockerOpened",
                "name": "unitOpened",
                "path": "/unit-opened"
            }
        ]
    },
    {
        "name": "unitOpened",
        "path": "/unit-opened",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            },
            {
                "key": "captureEquipmentImage",
                "name": "captureProductImage",
                "path": "/capture-product-image"
            },
            {
                "key": "assignedLockers",
                "name": "myRentedProducts",
                "path": "/my-rented-products"
            }
        ]
    },
    {
        "name": "myRentedProducts",
        "path": "/my-rented-products",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            },
            {
                "key": "lockerOpened",
                "name": "unitOpened",
                "path": "/unit-opened"
            }
        ]
    },
    {
        "name": "captureProductImage",
        "path": "/capture-product-image",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "paymentSuccessful",
                "name": "paymentSuccessful",
                "path": "/payment-successful"
            },
            {
                "key": "assignedLockers",
                "name": "myRentedProducts",
                "path": "/my-rented-products"
            }
        ]
    },
    {
        "name": "paymentSuccessful",
        "path": "/payment-successful",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            },
            {
                "key": "invoice",
                "name": "invoice",
                "path": "/invoice"
            }
        ]
    },
    {
        "name": "invoice",
        "path": "/invoice",
        "exitPages": [
            {
                "key": "home",
                "name": "equipmentGrid",
                "path": "/equipment-grid"
            }
        ]
    },
    {
        "name": "menuDrawer",
        "path": "/custom-drawer",
        "exitPages": [
            {
                "key": "assignedLockers",
                "name": "myRentedProducts",
                "path": "/my-rented-products"
            },
            {
                "key": "about",
                "name": "about",
                "path": "/about-screen"
            },
            {
                "key": "termsAndConditions",
                "name": "termsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "privacyPolicy",
                "name": "privacyPolicy",
                "path": "/privacy-policy"
            },
            {
                "key": "frequentlyAskedQuestions",
                "name": "frequentlyAskedQuestions",
                "path": "/faq"
            },
            {
                "key": "contactUs",
                "name": "contactUs",
                "path": "/contact-us"
            },
            {
                "key": "logout",
                "name": "logout",
                "path": null
            }
        ]
    }
];
  

export const DYNAMIC_PAGE_FLOW = [
    {
        "name": "qrCodeLanding",
        "path": "/locker-bank/:domainAndLockerBankInfoInBase64",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "linkMyDevice",
        "path": "/link-my-device",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "accessLockerBank",
        "path": "/",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "assignmentSelection",
        "path": "/assignments",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            }
        ]
    },
    {
        "name": "login",
        "path": "/login-page",
        "exitPages": [
            {
                "key": "verifyOtp",
                "name": "verifyOtp",
                "path": "/verify-otp"
            },
            {
                "key": "termsAndConditions",
                "name": "FonzelTermsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "linkMyDevice",
                "name": "linkMyDevice",
                "path": "/link-my-device"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "verifyOtp",
        "path": "/verify-otp",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "home",
        "path": "/home-screen",
        "exitPages": [
            {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "lockerUnitSelection",
                "name": "lockerUnitSelection",
                "path": "/select-unit"
            },
            {
                "key": "openLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }
        ]
    },
    {
        "name": "lockerSizeSelection",
        "path": "/locker-size",
        "exitPages": [
            {
                "key": "lockerUnitSelection",
                "name": "lockerUnitSelection",
                "path": "/select-unit"
            },
            {
                "key": "openLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
        ]
    },
    {
        "name": "lockerUnitSelection",
        "path": "/select-unit",
        "exitPages": [
            {
                "key": "openLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            }
        ]
    },
    {
        "name": "swipeToOpenLocker",
        "path": "/swipe-to-open",
        "exitPages": [
            {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            }
        ]
    },
    {
        "name": "lockerOpened",
        "path": "/locker-opened",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "menuDrawer",
        "path": "/custom-drawer",
        "exitPages": [
            {
                "key": "about",
                "name": "about",
                "path": "/about-screen"
            },
            {
                "key": "termsAndConditions",
                "name": "termsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "support",
                "name": "support",
                "path": "/support-screen"
            },
            {
                "key": "logout",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            }
        ]
    },
     {
        "name": "map",
        "path": "/map",
        "exitPages": [
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "lockerdetails",
                "name": "lockerdetails",
                "path": "/locker-details"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }

        ]
    },
    {
        "name": "lockerdetails",
        "path": "/locker-details",
        "exitPages": [
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "bookingsummary",
                "name": "bookingsummary",
                "path": "/booking-summary"
            },
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }

        ]
    },
];

export const LUGGAGE_PAGE_FLOW = [
    {
        "name": "qrCodeLanding",
        "path": "/locker-bank/:domainAndLockerBankInfoInBase64",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "accessLockerBank",
        "path": "/",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "assignmentSelection",
        "path": "/assignments",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            }
        ]
    },
    {
        "name": "login",
        "path": "/login-page",
        "exitPages": [
            {
                "key": "verifyOtp",
                "name": "verifyOtp",
                "path": "/verify-otp"
            },
            {
                "key": "termsAndConditions",
                "name": "DuroltLuggageLockerTermsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            }
        ]
    },
    {
        "name": "verifyOtp",
        "path": "/verify-otp",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "home",
        "path": "/home-screen",
        "exitPages": [
            {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "openLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
            {
                "key": "invoice",
                "name": "invoice",
                "path": "/invoice"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            },
        ]
    },
    {
        "name": "lockerSizeSelection",
        "path": "/locker-size",
        "exitPages": [
            {
                "key": "paymentGateway",
                "name": "paymentGateway",
                "path": "/payment-details"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "bookingsummary",
                "name": "bookingsummary",
                "path": "/booking-summary"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
           
        ]
    },
    {
        "name": "bookingsummary",
        "path": "/booking-summary",
        "exitPages": [
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "paymentGateway",
                "name": "paymentGateway",
                "path": "/payment-details"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            }
        ]
    },
    {
        "name": "paymentGateway",
        "path": "/payment-details",
        "exitPages": [
            {
                "key": "successPage",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "cancelOrErrorPage",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
        ]
    },
    {
        "name": "swipeToOpenLocker",
        "path": "/swipe-to-open",
        "exitPages": [
            {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            }
        ]
    },
    {
        "name": "lockerOpened",
        "path": "/locker-opened",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "menuDrawer",
        "path": "/custom-drawer",
        "exitPages": [
            {
                "key": "about",
                "name": "about",
                "path": "/about-screen"
            },
            {
                "key": "termsAndConditions",
                "name": "DuroltLuggageLockerTermsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "support",
                "name": "support",
                "path": "/support-screen"
            },
            {
                "key": "logout",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "invoice",
                "name": "invoice",
                "path": "/invoice"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            }
        ]
    },
    {
        "name": "userAccount",
        "path": "/user-account",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
            {
                "key": "invoice",
                "name": "invoice",
                "path": "/invoice"
            }
        ]
    },
    {
        "name": "map",
        "path": "/map",
        "exitPages": [
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "lockerdetails",
                "name": "lockerdetails",
                "path": "/locker-details"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }

        ]
    },
    {
        "name": "lockerdetails",
        "path": "/locker-details",
        "exitPages": [
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "map",
                "name": "map",
                "path": "/map"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            },
            {
                "key": "bookingsummary",
                "name": "bookingsummary",
                "path": "/booking-summary"
            },


        ]
    },
];
  

export const PARCEL_PAGE_FLOW = [
    {
        "name": "qrCodeLanding",
        "path": "/locker-bank/:domainAndLockerBankInfoInBase64",
        "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "accessLockerBank",
        "path": "/",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "dropPickupSelection",
                "name": "dropPickupSelection",
                "path": "/drop-pickup-selection"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "assignmentSelection",
        "path": "/assignments",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            }
        ]
    },
    {
        "name": "DropPickupSelection",
        "path": "/drop-pickup-selection",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            }
        ]
    },
    {
        "name": "login",
        "path": "/login-page",
        "exitPages": [
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "verifyOtp",
                "name": "verifyOtp",
                "path": "/verify-otp"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "doorVerificationPage",
                "name": "doorVerificationPage",
                "path": "/parcel-pickup-door-verification"
            },
            {
                "key": "parcelOwner",
                "name": "parcelOwner",
                "path": "/parcel-owner"
            },
            {
                "key": "connectMobile",
                "name": "connectMobile",
                "path": "/connect-mobile"
            },
            {
                "key": "termsAndConditions",
                "name": "FonzelTermsAndConditions",
                "path": "/terms-and-conditions"
            }
        ]
    },
    {
        "name": "verifyOtp",
        "path": "/verify-otp",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "parcelOwner",
                "name": "parcelOwner",
                "path": "/parcel-owner"
            },
        ]
    },
    {
        "name": "home",
        "path": "/home-screen",
        "exitPages": [
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "openLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "paymentGateway",
                "name": "paymentGateway",
                "path": "/payment-details"
            },
            {
                "key": "lockerOpened",
                "name": "dropAndPickupParcel",
                "path": "/drop-parcel"
            },
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }
        ]
    },
    {
        "name": "lockerSizeSelection",
        "path": "/locker-size",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "parcelOwner",
                "name": "parcelOwner",
                "path": "/parcel-owner"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }
        ]
    },
    
    {
        "name": "dropAndPickupParcel",
        "path": "/drop-parcel",
        "exitPages": [
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
        ]
    },
    {
        "name": "paymentGateway",
        "path": "/payment-details",
        "exitPages": [
            {
                "key": "successPage",
                "name": "dropAndPickupParcel",
                "path": "/drop-parcel"
            },
            {
                "key": "cancelOrErrorPage",
                "name": "home",
                "path": "/home-screen"
            }
        ]
    },
    {
        "name": "menuDrawer",
        "path": "/custom-drawer",
        "exitPages": [
            {
                "key": "about",
                "name": "about",
                "path": "/about-screen"
            },
            {
                "key": "termsAndConditions",
                "name": "termsAndConditions",
                "path": "/terms-and-conditions"
            },
            {
                "key": "support",
                "name": "support",
                "path": "/support-screen"
            },
            {
                "key": "logout",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "userAccount",
                "name": "userAccount",
                "path": "/user-account"
            }
        ]
    },
    {
        "name":"doorVerificationPage",
        "path":"/parcel-pickup-door-verification",
         "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "login",
                "name": "login",
                "path": "/login-page"
            },
            {
                "key": "swipeToOpenLocker",
                "name": "swipeToOpenLocker",
                "path": "/swipe-to-open"
            },
            {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            },
        ]
    },
    {
        "name":"swipeToOpenLocker",
        "path":"/swipe-to-open",
         "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
             {
                "key": "lockerOpened",
                "name": "lockerOpened",
                "path": "/locker-opened"
            },
        ]
    },
    {
        "name":"lockerOpened",
        "path":"/locker-opened",
         "exitPages": [
            {
                "key": "accessLockerBank",
                "name": "accessLockerBank",
                "path": "/"
            },
            {
                "key": "home",
                "name": "home",
                "path": "/home-screen"
            },
        ]
    },
    {
        "name": "parcelOwner",
        "path": "/parcel-owner",
        "exitPages": [
            {
                "key": "lockerSizeSelection",
                "name": "lockerSizeSelection",
                "path": "/locker-size"
            },
            {
                "key": "lockerUnitSelection",
                "name": "lockerUnitSelection",
                "path": "/select-unit"
            },
            {
                "key": "dropParcel",
                "name": "dropParcel",
                "path": "/drop-parcel"
            },
            {
                "key": "menuDrawer",
                "name": "menuDrawer",
                "path": "/custom-drawer"
            }

        ]
    },
    {
        "name": "lockerUnitSelection",
        "path": "/select-unit",
        "exitPages": [
            {
                "key": "parcelOwner",
                "name": "parcelOwner",
                "path": "/parcel-owner"
            },
            {
                "key": "dropParcel",
                "name": "dropParcel",
                "path": "/drop-parcel"
            },
        ]
    },

];
